import styled from 'styled-components/macro';
import { Divider } from '.';

export const CheckDivider = styled(Divider)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider.check};
  margin: 9px 0 10px 0;
  width: 90%;
`;
